module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Critical Praise for Amiri Baraka’s")])]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALES OF THE")]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UT")]), _vm._v(" & "), _c('span', {
    staticClass: "small"
  }, [_vm._v("THE")]), _vm._v(" G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONE")]), _vm._v(" (2007)")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_c('b', [_vm._v("•")]), _vm._v(" Winner of a PEN/Beyond Margins Award")]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_c('b', [_vm._v("•")]), _vm._v(" A "), _c('i', [_vm._v("New York Times")]), _vm._v(" Editors’ Choice")]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_c('b', [_vm._v("•")]), _vm._v(" An "), _c('i', [_vm._v("Essence Magazine")]), _vm._v(" Best Seller")]), _vm._v(" "), _c('p', {
    staticClass: "tx12"
  }, [_vm._v("“As this new collection of short fiction (most of it previously unpublished) makes clear, the writer formerly known as LeRoi Jones possesses an outtelligence of a high order. Baraka is such a provocateur, so skilled at prodding his perceived enemies (who are legion) in their tender underbellies, that it becomes easy to overlook that he is first and foremost a writer … He writes crisp, punchy sentences and has a fine ear for dialogue … In his prose as in his poetry, Baraka is at his best a lyrical prophet of despair who transfigures his contentious racial and political views into a transcendent, ‘outtelligent’ clarity.”")]), _vm._v(" "), _c('p', {
    staticClass: "right1"
  }, [_c('b', [_vm._v("—N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EW")]), _vm._v(" Y"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORK")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IMES")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OOK")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EVIEW")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_vm._v("“A marvelously vital and creative mind at work.”")]), _vm._v(" "), _c('p', {
    staticClass: "right1"
  }, [_c('b', [_vm._v("—L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IBRARY")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OURNAL")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_vm._v("“Baraka remains a prodigiously skilled writer. "), _c('i', [_vm._v("Tales of the Out & the Gone")]), _vm._v(" is an apt reminder of Baraka’s unique ability to touch on politics, race, and identity in a biting vernacular style.”")]), _vm._v(" "), _c('p', {
    staticClass: "right1"
  }, [_c('b', [_vm._v("—T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IME")]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UT")]), _vm._v(" N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EW")]), _vm._v(" Y"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORK")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_vm._v("“In his signature politically piercing and poetic staccato style, Baraka offers a perspective on social and political changes and a fresh view of the possibilities that language presents in exploring human passions … Fans and newcomers alike will appreciate Baraka’s breadth of political perspective and passion for storytelling.”")]), _vm._v(" "), _c('p', {
    staticClass: "right1"
  }, [_c('b', [_vm._v("—B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OOKLIST")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_vm._v("“Baraka’s ability to load his words with so much artillery results from his understanding of storytelling … Though the resolutions are often delivered like gut-shot punch lines, the circumstances behind the varied plots are complex, and are something too few people take the time to confront.”")]), _vm._v(" "), _c('p', {
    staticClass: "right1"
  }, [_c('b', [_vm._v("—S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AN")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RANCISCO")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRONICLE")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_vm._v("“Baraka makes his prose jump with word coining—‘outtelligent,’ ‘overstand’—and one-liners … The humor and off-the-wall jaunts tackle real issues of race, otherness, and power with pointed irony.”")]), _vm._v(" "), _c('p', {
    staticClass: "right1"
  }, [_c('b', [_vm._v("—N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EW")]), _vm._v(" Y"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORK")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RESS")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_vm._v("“This literary elder’s work, no matter what genre, has never failed to excite, never failed to elucidate and examine the human condition with scathing insight … The book’s charm lies in its tautness. No words wasted here. "), _c('i', [_vm._v("Tales")]), _vm._v(" commands you to pay close attention, lest you miss a great joke or a heartbreaking truth.”")]), _vm._v(" "), _c('p', {
    staticClass: "right1"
  }, [_c('b', [_vm._v("—B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LACK")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SSUES")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OOK")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EVIEW")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_vm._v("“Baraka unabashedly steps on toes, but does it in such a way that you close the book thanking him for it. He bends the English language to his liking without stopping to explain himself, which is refreshing from both ideological and technical perspectives.”")]), _vm._v(" "), _c('p', {
    staticClass: "right1"
  }, [_c('b', [_vm._v("—I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("DAHO")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TATESMAN")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_vm._v("“The short fiction here shows controversy is nothing new for the last poet laureate of New Jersey … Baraka certainly hasn’t gone soft.”")]), _vm._v(" "), _c('p', {
    staticClass: "right1"
  }, [_c('b', [_vm._v("—T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IME")]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UT")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HICAGO")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_c('i', [_vm._v("“Tales of the Out & the Gone")]), _vm._v(" displays Baraka’s increasing literary playfulness, intellectual exploration, and passion for intuitive abstract language. The book introduces new readers to Baraka’s groundbreaking and ever-changing style.”")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('b', [_vm._v("—E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("BONY")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23d1fea2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/c2.vue
// module id = 60
// module chunks = 0